import React from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { MdLogin } from "react-icons/md";
import useProfile from '../../../Hooks/useProfile';
import swal from 'sweetalert';



const Navbar = () => {
    const [user] = useProfile();



    //handle Logout
    const navigate = useNavigate();
    const handleLogout = () => {
        swal('Logout Successfully', 'Your account logout successfully done', 'success');
        localStorage.removeItem('token');
        navigate('/');
    }

    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light Nav-menu fixed-top topNavbar">
                <div className="container-fluid ps-5 pe-5">
                    <Link className="navbar-brand" to="/"><img src='https://cdn.10minuteschool.com/images/svg/10mslogo-svg.svg' alt='logo' className='img-fluid' style={{ height: 'auto', width: '100px' }} /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 submenu">
                            <li className="nav-item">
                                <NavLink className="nav-link" aria-current="page" to="/class1to12">ক্লাস ১-১২</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/skills">স্কিলস </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/admission">ভর্তি পরীক্ষা </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/jobPreperation">  চাকরি প্রস্তুতি </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/bookStore">  বুক স্টোর </NavLink>
                            </li>
                        </ul>

                        {/* Profile  */}
                        <div className="dropdown">
                            {
                                user?.email ? <li className="nav-item dropdown" style={{ listStyle: 'none' }}>
                                    <Link className="nav-link dropdown-toggle" to="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
                                        <img src={user?.profile} alt={user?.name} className='img-fluid rounded-pill' style={{ height: '30px', width: '30px' }} />
                                    </Link>
                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <li><NavLink className="dropdown-item fs-6" to="/profile">Profile</NavLink></li>
                                        <hr className='m-0 p-0' />
                                        <li><Link className="dropdown-item fs-6" to="" onClick={handleLogout}>Logout</Link></li>
                                    </ul>
                                </li> : <Link to='/login'><span className='nav-link fs-5 fw-bold text-light btn btn-danger'><MdLogin className='me-1' />লগ ইন</span></Link>
                            }
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;